import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'

import config from './config'

export function initializeFirebase() {
  return firebase.initializeApp(config)
}
